import { useNavigate } from 'react-router-dom'
import { routes } from '@/app/routes'
import { useSubscriptionStore } from '@/features/subscription/subscription.store'
import { DsAlert, DsIcons } from '@/ds'
import { subscriptionStrings } from '@/features/subscription/strings'

export function PendingUpgradeBanner() {
  const pending = useSubscriptionStore((s) => s.pending)
  const navigate = useNavigate()
  if (!pending?.planType) return null
  return <DsAlert tone="warning" icon={DsIcons.hourglass} title={subscriptionStrings.upgradeInProgress(pending.planType)} actionLabel={subscriptionStrings.view} onAction={() => navigate(routes.landlord.subscriptions)} bleed />
}
